module.exports = __webpack_public_path__ + "static/media/tekura3.2c8ea50a.jpg";